export type LayoutOptions = {
  amount?: number;
  currency?: string;
};

function updatePayButton(form: Element, options: LayoutOptions) {
  const button = form.querySelector(".wpwl-button-pay, button[type='submit']") as HTMLButtonElement | null;
  if (!button) return;

  button.classList.add("credit-card-form__pay-btn");
  const label =
    options.amount != null && options.amount > 0 && options.currency
      ? `Pay ${options.amount.toFixed(2)} ${options.currency.trim()} securely`
      : "Complete secure payment";

  if (button.textContent !== label) button.textContent = label;
}

/** Ensure OPPWA label nodes match our field names when present. */
function fixOppwaFieldLabels(form: Element) {
  const labelFixes: Array<[string, string]> = [
    [".wpwl-group-cardHolder", "Name on card"],
    [".wpwl-group-cardNumber", "Card Number"],
    [".wpwl-group-expiry", "Expiry date"],
    [".wpwl-group-cvv", "CVV"],
  ];

  labelFixes.forEach(([groupSelector, text]) => {
    const group = form.querySelector(groupSelector);
    if (!group) return;

    const label = group.querySelector(".wpwl-label, label");
    if (label) {
      label.textContent = text;
    }
  });
}

/**
 * Cosmetic polish only — never move/remove OPPWA DOM nodes.
 * Moving PCI iframe containers breaks validateInput / submit (PciIframeSubmitError).
 */
export function layoutOppwaWidget(container: HTMLElement, options: LayoutOptions = {}): boolean {
  const form = container.querySelector("form.wpwl-form-card");
  if (!form) return false;

  form.classList.add("credit-card-form__oppwa-form");

  const holder = form.querySelector(".wpwl-group-cardHolder");
  const number = form.querySelector(".wpwl-group-cardNumber");
  const expiry = form.querySelector(".wpwl-group-expiry");
  const cvv = form.querySelector(".wpwl-group-cvv");

  if (!holder || !number || !expiry || !cvv) return false;

  fixOppwaFieldLabels(form);
  updatePayButton(form, options);
  form.dataset.layoutDone = "true";
  return true;
}
